import type { GetPaths } from "@marko/run/namespace";
client import { pickBy } from "es-toolkit";
export interface Input<T> {
  catch: Marko.AttrTag<{ content: Marko.Body<[unknown]> }>;
  content: Marko.Body<[T]>;
  placeholder?: Marko.AttrTag<{ content: Marko.Body }>;
  src: GetPaths;
}
server const isServer = true;

<const/loader=(
  (isServer
    ? $global.fetch(input.src, {
        headers: $global.request.headers,
      })
    : fetch(input.src, {
        headers: pickBy(
          {
            Accept: "application/json",
            "Cache-control": $global.isHardReload ? "no-cache" : undefined,
            "X-Clarity": "true",
            "X-Requested-With": "XMLHttpRequest",
          },
          Boolean,
        ) as HeadersInit,
        signal: $signal,
      })
  )
    .then((response) => {
      if (response?.ok) {
        return response.json();
      } else {
        throw new Error(`Error fetching ${input.src}`);
      }
    })
    .catch((error) => {
      if (error.name === "AbortError") {
        return "";
      }
      throw error;
    })
)>

<key=input.src>
  <try>
    <if=(!isServer || $global.hasClientJs) && input.placeholder>
      <@placeholder>
        <${input.placeholder}/>
      </@placeholder>
    </if>

    <@catch|error: unknown|>
      <${input.catch}(error)/>
    </@catch>

    <await|payload|=loader>
      <${input.content}(payload)/>
    </await>
  </try>
</key>
